'use client';

/**
 * Fog background system disabled — was causing performance issues.
 * The animated aurora/stars/STEVE canvas renderer consumed significant
 * CPU/GPU resources. Components preserved in AnimatedFogBackground.tsx
 * and AnimatedFogBackgroundWebGL.tsx if re-enabling is needed later.
 */
export function ConditionalFogBackground() {
  return null;
}

export default ConditionalFogBackground;
